import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { ButtonEvent } from './button-event';
import { ButtonStyle, ButtonType } from './button-type';

/**
 * Button component.
 */

export class ButtonComponent implements OnInit {
  /**
   * Indicates button should automatically get focus when the page loads
   */
   autofocus: boolean = false;

  /**
   * The disabled state
   */
   disabled: boolean = false;

  /**
   * Specifies one or more forms the button belongs to
   */
   form: string;

  /**
   * Specifies where to send the form-data (a URL) when a form is submitted. Only for type submit
   */
   formAction: string;

  /**
   * Specifies how form-data should be encoded before sending it to a server. Only for type submit
   *
   * See [[ButtonFormEncType]]
   */
   formEncType: string;

  /**
   * Specifies how to send the form-data (which HTTP method to use). Only for type submit
   *
   * See [[ButtonFormMethod]]
   */
   formMethod: string;

  /**
   * Specifies that the form-data should not be validated on submission. Only for type submit
   */
   formNoValidate: boolean = false;

  /**
   * Specifies where to display the response after submitting the form. Only for type submit
   *
   * See [[ButtonFormTarget]]
   */
   formTarget: string;

  /**
   * The button ID
   */
   id: string;

  /**
   * The button name
   */
   name: string;

  /**
   * The button style
   *
   * See [[ButtonStyle]]
   */
   style: string = ButtonStyle.DEFAULT;

  /**
   * The button tooltip
   */
   tooltip: string;

  /**
   * The button type
   *
   * See [[ButtonType]]
   */
   type: string = ButtonType.BUTTON;

  /**
   * The initial button value
   */
   value: string;

  /**
   * The event emitted when a button has been clicked
   */
   onClick = new EventEmitter();

  /**
   * The default constructor
   */
  constructor() {
  }

  // Initialization

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
  }

  // Actions

  handleClick($event: MouseEvent): void {
    this.onClick.emit({
      eventName: 'onClick',
      id: this.id,
      name: this.name,
      value: this.value
    } as ButtonEvent);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-button',
  template: `<button class="pf-c-button" [attr.form]="form" [attr.formaction]="formAction" [attr.formenctype]="formEncType" [attr.formmethod]="formMethod" [attr.formnovalidate]="formNoValidate" [attr.formtarget]="formTarget" [autofocus]="autofocus" [disabled]="disabled" [id]="id" [name]="name" [ngClass]="{
          'pf-m-danger': style === 'danger',
          'pf-m-primary': style === 'primary',
          'pf-m-secondary': style === 'secondary',
          'pf-m-tertiary': style === 'tertiary',
          'pf-m-link': style === 'link',
          'pf-m-action': style === 'action',
          'pf-m-disabled': style === 'disabled'
        }" [title]="tooltip" [type]="type" [value]="value" (click)="handleClick($event)"><ng-content></ng-content></button>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'autofocus': [{ type: Input },],
'disabled': [{ type: Input },],
'form': [{ type: Input },],
'formAction': [{ type: Input },],
'formEncType': [{ type: Input },],
'formMethod': [{ type: Input },],
'formNoValidate': [{ type: Input },],
'formTarget': [{ type: Input },],
'id': [{ type: Input },],
'name': [{ type: Input },],
'style': [{ type: Input },],
'tooltip': [{ type: Input },],
'type': [{ type: Input },],
'value': [{ type: Input },],
'onClick': [{ type: Output, args: ['onClick', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
